import React from 'react';
import { FormattedMessage } from 'react-intl-next';

import Button from '@atlaskit/button/new';
// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { Box, Inline, xcss } from '@atlaskit/primitives';

import { messages } from '../../messages.ts';
import { useGetIsMissingColumnMappingError } from '../../providers/BulkCreateContextProvider.tsx';
import type { BulkConfigureFooterProps } from '../../__types__/BulkConfigureFooter.ts';

const footerBaseStyles = xcss({
	backgroundColor: 'elevation.surface',
	position: 'relative',
	flexShrink: 0,
	bottom: 'space.0',
	width: '100%',
	'::before': {
		content: '""',
		position: 'absolute',
		top: 'space.0',
		left: 'space.150',
		right: 'space.150',
		height: '1px',
		backgroundColor: 'elevation.surface',
		borderTopColor: 'color.border',
		borderTopStyle: 'solid',
		borderTopWidth: 'border.width',
	},
});

export const BulkConfigureFooter = ({
	onClose,
	closePanel,
	isSaveDisabled,
}: BulkConfigureFooterProps) => {
	const isMissingColumnMappingError = useGetIsMissingColumnMappingError();
	// We are directly navigating the user to the configure page if there are no issues to mapped.
	// Since the configure page doesn't have a way to close the side panel, we are changing the cancel button to allow the user to close the side panel in case they don't want to proceed.
	const onCancel = isMissingColumnMappingError ? closePanel : onClose;
	return (
		<Box paddingBlock="space.200" paddingInline="space.300" xcss={footerBaseStyles}>
			<Inline space="space.100" alignInline="end">
				<Button appearance="subtle" testId="configure-cancel-button" onClick={onCancel}>
					<FormattedMessage {...messages.bulkConfigureFooterCancel} />
				</Button>
				<Button
					type="submit"
					form="configureForm"
					appearance="primary"
					testId="configure-save-button"
					isDisabled={isSaveDisabled}
				>
					<FormattedMessage {...messages.bulkConfigureFooterSave} />
				</Button>
			</Inline>
		</Box>
	);
};
